<template>
  <div class="comment-list" >
    <CommentBlock
      v-for="cItem in CommentList"
      :key="cItem.Id"
      :info="cItem"
      :articleAuthorId='currCommentInfo.AuthorId'
      @showAllComment="showAllComment"
      @childrenComment="handlechildComment"
    />
    <div v-if="CommentList.length === 0" class="empty-comment">
      <i class="iconfont icon-pinglun1"></i>
      <div class="msg">还没评论 快来说两句</div>
    </div>
    <div v-if="CommentList.length !== 0" class="show-all text-gray">已显示全部评论</div>
    <commentListPopup
      ref="commentListPopup" 
      @onSendSuccess='onPopupSuccess'/>
    <sendCommentBar
      v-model="showCommentBox"
      :commentsCount='CommentList.length'
      :info.sync="currCommentInfo"
      @onSuccess="handleSendComment"
    />
  </div>
</template>
<script>
import { Comment } from "@/api";
import sendCommentBar from "@/components/comment/sendCommentBar.vue";
import CommentBlock from "@/components/comment/commentBlock.vue";
import commentListPopup from './commentListPopup.vue'
export default {
  components: {
    sendCommentBar,
    CommentBlock,
    commentListPopup
  },
  props: {
    ArticleId: {
      type: Number,
      required: true
    },
    AuthorId: {
      type: Number,
      required: true
    },
    isFav: {
      type: Boolean,
      required: true
    },
    ArticleType: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      UserId: 0,
      CommentList: [],
      commentType: this.ArticleType === 1 ? Comment.ModuleKey : Comment.VideoKey,
      currCommentInfo: {
        SourceId: this.ArticleId,
        AuthorId: this.AuthorId,
        isFav: this.isFav,
        name: '',
        commentType: this.ArticleType === 1 ? Comment.ModuleKey : Comment.VideoKey,
      },
      showCommentBox: false
    };
  },
  watch: {
    AuthorId(val) {
      this.currCommentInfo.AuthorId = val
    }
  },
  created() {
    this.UserId = this.$mdUtils.getUserInfo("Id")
    this.getCommentList();
  },
  methods: {
    getCommentList() {
      this.$api(Comment.QueryVCommentByPage, {
        AppId: 1,
        Module: this.commentType,
        SourceId: this.ArticleId,
        // UserId: this.$mdUtils.getUserInfo("Id"),
        PageIndex: 1,
        PageSize: 1000
      })
        .then(this.getMyCommentGood)
        .then(res => {
          if (res && res.List.length) {
            this.CommentList = this.makeTree(res.List);
          }
        });
    },
    getMyCommentGood(res) {
      return this.$api(Comment.QueryCommentGood, {
        AppId: 1,
        Module: this.commentType,
        SourceId: this.ArticleId,
        UserId: this.UserId
      }).then((qRes) => {
        res.List.forEach(coItem => {
          let goodItem = qRes.List.find((gItem) => gItem.CommentId == coItem.Id)

          if (goodItem) {
            coItem.isGood = true
            coItem.CommentGoodId = goodItem.Id
          } else {
            coItem.isGood = false
          }
        })

        return res
      }).catch(() => {
        return res
      })
    },
    handlechildComment(info) {
      this.currCommentInfo.ParentId = info.Id;
      this.currCommentInfo.name = info.UserName
      this.showCommentBox = true;
    },
    makeTree(arr) {
      let parentArr = [];
      let childrenArr = [];
      arr.forEach(item => {
        item.Children = [];
        if (item.ParentId != null) {
          childrenArr.push(item);
        } else {
          parentArr.push(item);
        }
      });

      childrenArr.forEach(cItem => {
        if (!cItem.Deleted) {
          let pItem = parentArr.find(p => p.Id == cItem.ParentId);
          pItem && pItem.Children.push(cItem);
        }
      });

      return parentArr;
    },
    handleSendComment() {
      this.showCommentBox = false;
      this.getCommentList();
    },
    showAllComment(commentInfo) {
      let info = {
        commentInfo: commentInfo,
        currCommentInfo: this.currCommentInfo,
        commentCount: this.CommentList.length,
        authorId: this.AuthorId
      }

      this.$refs.commentListPopup.init(info)
    },
    onPopupSuccess(data) {
      console.log(data)
    }
  }
};
</script>
<style lang='scss' scoped>
.comment-list {
  margin-top: 17px;
  padding-bottom: 15px;

  .show-all.text-gray {
    margin-left: 44px;
    font-size: $font-size-small;
  }

  .empty-comment {
    padding: 20px 0;
    text-align: center;

    .iconfont {
      font-size: 100px;
    }
    .msg {
      font-size: 14px;
    }
  }
}
</style>